import React, {Fragment} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/news";
import NewsClassificationModal from "./classificationModal";
import useFormModal from "../../utils/useFormModal";
import {Button, Divider, Popconfirm, Space} from "antd";
import WithAuth from "../../utils/withAuth";
import {useRequest} from "ahooks";

const AddButton = WithAuth('add', Button)
const EditFragment = WithAuth('edit', Fragment)
const DeletePopconfirm = WithAuth('delete', Popconfirm)

function NewsClassification() {

    const {tableProps, refresh} = useAntTable(api.getNewsClassifications, {})

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.modifyNewsClassifications,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    const {run: onDelete} = useRequest(api.deleteNewsClassifications, {
        manual: true,
        onSuccess: () => refresh()
    })

    const columns: StandardColumnsType = [
        {
            title: 'Name',
            dataIndex: 'name',
        },
        {
            title: 'Operations',
            dataIndex: 'operation',
            render: (_, record: any) => (
                <span>
                    <EditFragment>
                        <a onClick={() => setVisible(true, record)}>Edit</a>
                        <Divider type={'vertical'}/>
                    </EditFragment>
                    <DeletePopconfirm title={'Are you sure?'} onConfirm={() => onDelete(record.id)}>
                        <a>Delete</a>
                    </DeletePopconfirm>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable columns={columns} {...tableProps} toolbar={(
                <Space>
                    <AddButton type={'primary'} onClick={() => setVisible(true)}>Add</AddButton>
                </Space>
            )}/>
            <NewsClassificationModal {...modalProps} />
        </PageHeaderLayout>
    )
}

export default NewsClassification
